import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import '../styles/searchBar.css';
import hero from '../images/hero-bg.svg';
import {CustomButton} from './CustomButton';
import CustomRadioButton from './CustomRadioButton';
import CustomInput from './CustomInput';
import {FormattedMessage} from 'react-intl';
import {injectIntl} from 'react-intl';
import webclient from '../api/webClient';

class Search extends Component {
  state = {
    searchValue: '',
    searchType: 'registered',
    companyCount: 0
  };

  componentDidMount() {
    this.getCompanyCount();
  }
  getCompanyCount() {
    webclient
      .get('/Yrityksenperustiedot/HaeLkm')
      .then(response => {
        const count = response.data;
        this.setState({
          companyCount: count
        });
      })
      .catch(error => {
        //set a fallback value or error state
        this.setState({
          companyCount: 0
        });
      });
  }

  onChange = e => {
    this.setState({searchValue: e.target.value});
  };

  handleRadioChange = e => {
    this.setState({searchType: e.target.value});
  };

  onSubmit = (value, type) => {
    this.props.history.push({
      pathname: '/yritykset',
      search: `?nameorid=${value}&Type=${type}`
    });
    this.props.onSearch(value, type);
  };

  render() {
    const {formatMessage} = this.props.intl;

    return (
      <div
        style={{
          backgroundColor: '#EAECE2',
          width: '100%',
          height: '530px',
          backgroundImage: `url(${hero})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right bottom',
          backgroundSize: '300px auto',
          paddingTop: '48px',
          paddingLeft: '80px'
        }}
      >
        <h1 className="h1">
          <FormattedMessage id="search-bar-title" />
        </h1>
        <p className="body-lg" style={{maxWidth: '768px', marginBottom: '24px'}}>
          <FormattedMessage id="registry-count" /> {this.state.companyCount}
        </p>
        <h2 className="h2">
          <FormattedMessage id="search-from-register" />
        </h2>
        <CustomInput onChange={this.onChange} />
        <div style={{marginTop: '1rem', width: '15rem'}}>
          <CustomRadioButton
            label={formatMessage({id: 'registered'})}
            id="registered"
            name="type"
            value="registered"
            checked={this.state.searchType === 'registered'}
            tooltipMessageId="search_info-registrations"
            onChange={this.handleRadioChange}
          />
        </div>
        <div style={{marginTop: '0.6rem', width: '15rem'}}>
          <CustomRadioButton
            label={formatMessage({id: 'prohibited'})}
            id="prohibited"
            name="type"
            value="prohibited"
            checked={this.state.searchType === 'prohibited'}
            tooltipMessageId="search_info-prohibitions"
            onChange={this.handleRadioChange}
          />
        </div>
        <div style={{marginTop: '0.6rem', marginBottom: '1rem', width: '15rem'}}>
          <CustomRadioButton
            label={formatMessage({id: 'deleted'})}
            id="deleted"
            name="type"
            value="deleted"
            checked={this.state.searchType === 'deleted'}
            tooltipMessageId="search_info-deleted"
            onChange={this.handleRadioChange}
          />
        </div>
        <CustomButton
          className="button primary"
          onClick={() => this.onSubmit(this.state.searchValue, this.state.searchType)}
        >
          <FormattedMessage id="search" />
        </CustomButton>
      </div>
    );
  }
}

Search.propTypes = {
  onSearch: PropTypes.func.isRequired,
  history: PropTypes.any
};

export default withRouter(injectIntl(Search));
